import { Component, OnInit, Input, HostBinding, HostListener, ViewChild, ElementRef } from '@angular/core';
import { IUProperty } from 'src/app/shared/interface/umbraco-property';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { IPictureData } from '../../shared/components/picture/picture.component';
import { MqService } from '../../service/mq.service';
import { ILinkWithColor } from 'src/app/shared/interface/link';
import { IVideoPickerData } from 'src/app/shared/interface/video-picker-data';
import { IRteStyleSettings } from '../../shared/interface/rte-style-settings';
import { applyRteSettings } from '../../shared/utils/rte-style-settings-utils';

interface IBoardHeroVideoPanelData {
  title: IUProperty<string>;
  description: IUProperty<string>;
  video: IUProperty<IVideoPickerData>;
  links?: IUProperty<ILinkWithColor[]>;
  removeBackgroundOverlay?: IUProperty<boolean>;

  rteStyleSettings?: IRteStyleSettings;
}

export interface IVideoViewModel {
  video: object;
  thumbnail: IPictureData;
  params: string;
}

@Component({
  selector: 'app-board-hero-video-panel',
  templateUrl: './board-hero-video-panel.component.html',
  styleUrls: ['./board-hero-video-panel.component.less']
})

export class BoardHeroVideoPanelComponent implements OnInit {
  @Input() data: Partial<IBoardHeroVideoPanelData>;

  videoData: IVideoViewModel;
  isShow: boolean = false;
  media: IVideoPickerData;
  isMobile: boolean;

  constructor(
    private _sanitizer: DomSanitizer,
    private mq: MqService,
  ) { }

  @ViewChild('mediaHolder', {static: false}) mediaHolder: ElementRef;
  @ViewChild('contentHolder', { static: false }) contentHolder: ElementRef;
  @ViewChild('descriptionEl', { static: false }) descriptionEl: ElementRef<HTMLElement>;
  @ViewChild('panelEl', {static: false}) panelEl: ElementRef;

  @HostListener('window:resize', ['$event']) getScreenSize(event?) {
    this.changeMQData();
  }

  ngOnInit() {
    this.prepareVideo();
  }

  ngAfterViewInit(): void {
    applyRteSettings(this.data, this.descriptionEl);
    setTimeout(() => {
      this.changeMQData();
    }, 0)
  }

  private prepareVideo() {
    try {
      if (!this.data || !this.data.video || !this.data.video.value) return;

      const media = this.data.video.value;

      this.media = {
        desktop: media.desktop || media.mobile,
        mobile: media.mobile || media.desktop
      }
    } catch (err) {
      console.error('TODO: fix it please')
    }
  }

  changeMQData() {
    this.mq.mobileDesktop(
      () => {
        this.isMobile = true;
        const contentHolderHeight = this.contentHolder.nativeElement.scrollHeight;
        if (this.mediaHolder && this.mediaHolder.nativeElement) {
          this.mediaHolder.nativeElement.style.height = this.getVideoHeight() > contentHolderHeight ? this.getVideoHeight() + 'px' : contentHolderHeight + 'px';
        }
        if (this.panelEl && this.panelEl.nativeElement && this.contentHolder && this.contentHolder.nativeElement) {
          this.panelEl.nativeElement.style.height = this.getVideoHeight() > contentHolderHeight ? this.getVideoHeight() + 'px' : contentHolderHeight + 'px';
        }
      }, 
      () => {
        this.isMobile = false;
        if (this.mediaHolder && this.mediaHolder.nativeElement) {
          this.mediaHolder.nativeElement.style.height = this.getVideoHeight() + 'px';
        }
        if (this.panelEl && this.panelEl.nativeElement && this.contentHolder && this.contentHolder.nativeElement) {
          const contentHolderHeight = this.contentHolder.nativeElement.scrollHeight;
          this.panelEl.nativeElement.style.height = this.getVideoHeight() > contentHolderHeight ? this.getVideoHeight() + 'px' : contentHolderHeight + 'px';
        }
      }
    );
  }

  getVideoHeight() {

    return (this.mediaHolder.nativeElement.scrollWidth || 0) * (7 / 16);
  }
}

